var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUnpaidInviteWelcomeAccentLine({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 754,
    height: 24,
    viewBox: "0 0 754 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.50023 11.5972C119.702 3.92453 431.599 -5.13091 749.57 20.0288",
    stroke: "#60C2A5",
    strokeWidth: 7,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUnpaidInviteWelcomeAccentLine);
export default __webpack_public_path__ + "static/media/unpaid-invite-welcome-accent-line.7e4367a4f50d01f2c81600b89774f263.svg";
export { ForwardRef as ReactComponent };